import { useExtensionList } from '@confluence/forge-ui/entry-points/useExtensionList';
import { FORGE_MODULE_HOMEPAGE_FEED } from '@confluence/forge-ui';

const useForgeAppsVisible = () => {
	const { extensions } = useExtensionList({
		moduleType: FORGE_MODULE_HOMEPAGE_FEED,
	});

	return Array.isArray(extensions) && extensions.length > 0;
};

export const useRightPanelVisible = () => {
	const shouldShowForgeApps = useForgeAppsVisible();

	const shouldShowRightPanel = shouldShowForgeApps;

	return {
		shouldShowRightPanel,
		shouldShowForgeApps,
	};
};
